/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {StarStruckGameConfig} from "../StarStruckGameConfig";
import BitmapText = PIXI.BitmapText;

export interface IStarStruckSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
}

export class StarStruckReelSymbol extends StateReelSymbol {
    private _winBackground:TimelineSprite;
    private _symIdleAnimation:TimelineSprite;
    private _multiplier:BitmapText;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations():void {

        if(!this._winBackground) {
            this._winBackground = new TimelineSprite(GameResources.getTextures("symWinBgAnimation"));
            this._winBackground.anchor.set(0.5, 0.5);
            this._winBackground.position.set(0, 0);
            this._winBackground.hide();
            this._winBackground.blendMode = PIXI.BLEND_MODES.ADD;
        }

        if(!this._symIdleAnimation) {
            this._symIdleAnimation = new TimelineSprite(GameResources.getTextures("symIdleAnimation"));
            this._symIdleAnimation.anchor.set(0.5, 0.5);
            this._symIdleAnimation.position.set(0, 0);
            this._symIdleAnimation.hide();
            this._symIdleAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        }

        if(!this._multiplier) {
            const text:BitmapText = new BitmapText("X0", {
                fontName : "NumbersWinCountUp",
                fontSize : 20
            });
            text.position.set(-text.width / 2, -text.height / 2);
            text.alpha = 0;
            this._multiplier = text;
        }
    }

    protected getStateChangingAnimation(transitionConfig:SymbolStateTransition):Timeline {
        if(transitionConfig.state.keyword === StarStruckGameConfig.instance.SYMBOL_STATES.idle!.keyword) {
            this.addChild(this._symIdleAnimation);
            this._symIdleAnimation.getAnimationAutoShowHide(true, true);
        }
        return super.getStateChangingAnimation(transitionConfig);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === StarStruckGameConfig.instance.SYMBOL_STATES.win.keyword) {
            this.addChild(this._winBackground);
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.1, {x : 1, y : 1}));
            winTl.add(new TweenLite(this.scale, 0.4, {x : 1, y : 1}));
            timeline.add([
                winTl,
                this._winBackground.getAnimationAutoShowHide(true, true)
            ], delay);
            return;
        }

        if(newState.state.keyword === StarStruckGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(() => stateAnimation.tint = 0xffffff, delay);
        }
    }

    public addMultiplier(multiplier:number):void {
        this._multiplier.text = "X" + multiplier.toString();
        this._multiplier.position.set(-this._multiplier.width / 2, -this._multiplier.height / 2);
        this._multiplier.alpha = 1;
        this.addChild(this._multiplier);
    }

    protected reset(remove:boolean):void {
        super.reset(remove);
        if(this._multiplier) {
            this._multiplier.alpha = 0;
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            // To move the patches always on the top.
            if(this._multiplier) {
                this.addChild(this._multiplier);
            }
            return true;
        }

        return false;
    }
}